var map = {
	"./addliquidity.json": 1208,
	"./box.json": 1209,
	"./components.json": 1210,
	"./constants.json": 1211,
	"./error.json": 1212,
	"./farm.json": 1213,
	"./home.json": 1214,
	"./launchpad.json": 1215,
	"./menu.json": 1216,
	"./minning.json": 1217,
	"./nft.json": 1218,
	"./pool.json": 1219,
	"./referral.json": 1220,
	"./removeliquidity.json": 1221,
	"./rolling.json": 1222,
	"./swap.json": 1223,
	"./team.json": 1224,
	"./uikit.json": 1225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1207;